import React, { useMemo, useState, useContext } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleSalesRegionDetails = () => {
  const { regionId } = useParams();
  const navigate = useNavigate();
  const decodedId = regionId ? atob(regionId) : regionId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);
  const { showToast } = useContext(ToastContext);

  const url = id ? API_DOMAIN + API_ROUTES['salesRegion'] + id + '/' : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['salesRegion'] + id + '/', { headers });
      showToast('Sales Region deleted successfully', 'success');
      navigate('/lead/sales-region/list');
    } catch (error) {
      console.error('Error deleting SalesRegion:', error);
      showToast('Failed to delete Sales Region', 'error');
    } finally {
      setShowDelete(false);
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Sales Region"
        listPath="/lead/sales-region/list"
        editPath={`/lead/sales-region/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this Sales Region?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleSalesRegionDetails;
